import { AnalyticsBrowser } from '@segment/analytics-next'
import { env, app } from 'config'
import { experimentTrackingMiddleware } from 'utils/experiments'

export const analytics = new AnalyticsBrowser()

analytics.addSourceMiddleware(experimentTrackingMiddleware)

if (app.analyticsEnabled) {
  analytics.load(
    { writeKey: env.REACT_APP_SEGMENT_API_KEY },
    {
      // Enable `keepalive` to improve event tracking reliability for events triggered
      // just before hard-redirects.
      //
      // ref: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#keepalive
      //
      integrations: {
        'Segment.io': {
          deliveryStrategy: {
            config: {
              keepalive: true
            }
          }
        }
      }
    }
  )
}
